module.exports = __webpack_public_path__ + "img/Image_logo_1.e4f12d8b.jpg";